export default __webpack_public_path__ + "static/media/raleway-regular.9ade142e.ttf";